import React, { Component } from 'react';
import {ApiBaseUrl, StripeKey} from '../../../constants';
import { AuthContext } from "./../../../context/auth";
import { trackPromise } from 'react-promise-tracker';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import SplitForm from './SplitForm';
import {withSnackbar} from "react-simple-snackbar";

class PaymentComponent extends Component{
    static contextType = AuthContext;
    stripePromise = loadStripe(StripeKey);
    state = {
        promo_applied: false,
        consumerprice:'',
        consumer_order_cost:''
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/pick_deal/"+this.props.match.params.id,
            {
                method: 'POST',
                body: '',
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else
                        this.setState({
                            consumerprice:result.data.deal.consumerprice,
                            consumer_order_cost:result.data.deal.consumer_order_cost
                        });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }
    render(){
        return (
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="container-payment">
                        <div className="payment-gateway-outer">
                            <div className="payment-apply-promo-outer">
                                <Elements stripe={this.stripePromise}>
                                    <SplitForm id={this.props.match.params.id} promo_applied={this.state.promo_applied} consumer_order_cost={this.state.consumer_order_cost} consumerprice={this.state.consumerprice} last_used_promo={this.context.lastUsedPromo}/>
                                </Elements>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withSnackbar(PaymentComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});